// extracted by mini-css-extract-plugin
module.exports = {"buyable-info":"shopping-item_buyable-info__79wGy","buyable-title":"shopping-item_buyable-title__NPdBb","buyable-instructors":"shopping-item_buyable-instructors__dI7az"};